export const router = {
  path: "empowerment",
  name: "empowerment",
  meta: {
    title: "优越赋能",
    title_en: "empowerment",
    showOnNavMenu: true,
    navMenuMode: "custom",
    iconfont: "icon-chanpin",
    dropDown: true,
    subBar: true,
  },
  redirect() {
    return { name: "proKnowledgeShare" };
  },
  children: [
    {
      path: "proKnowledgeShare",
      name: "proKnowledgeShare",
      meta: {
        title: "行业知识分享",
        dropDown: false,
        showOnNavMenu: true,
      },
      component: () => import("@/views/empowerment/knowledgeShare/index.vue"),
    },
    {
      path: "videoShare",
      name: "videoShare",
      meta: {
        title: "知识视频分享",
        dropDown: false,
        showOnNavMenu: true,
      },
      component: () => import("@/views/empowerment/videoShare/index.vue"),
    },
    {
      path: "shareDetail",
      name: "shareDetail",
      meta: {
        title: "知识详情",
        dropDown: false,
        showOnNavMenu: false,
      },
      component: () =>
        import("@/views/empowerment/newsDetails/newsDetails.vue"),
    },
  ],
};
